import { createActionGroup, props } from '@ngrx/store';
import { HistoryEntry } from '@models';

export const HistoryEntriesActions = createActionGroup({
  source: 'History Entries',
  events: {
    'Load Scope': props<{ projectId: string; scopeKey: string }>(),
    'Load Scope Succeeded': props<{ entries: HistoryEntry[] }>(),
    'Load Scope Failed': props<{ error: string }>(),
    'Add Entry': props<{ entry: HistoryEntry }>(),
    'Entry Saved': props<{ entry: HistoryEntry }>(),
    'Add Entry Failed': props<{ error: string }>(),
  },
});
